import { previewFileConstants } from '../constants';

const initialState = {};

export const previewFile = (
  state = initialState,
  action: { type: string; payload: any },
) => {
  switch (action.type) {
    case previewFileConstants.PREVIEW_FILE_SHOW:
      return {
        url: action.payload.url,
        mimeType: action.payload.mimeType,
      };
    case previewFileConstants.PREVIEW_FILE_CLOSE:
      return {};
    case previewFileConstants.PREVIEW_FILE_WITH_PAGE_SHOW:
      return {
        allPages: action.payload.allPages,
        currentIndex: action.payload.currentIndex,
      };
    case previewFileConstants.UPDATE_CURRENT_INDEX:
      if (action.payload.index === undefined)
        throw Error(`payload.index is required`);
      return {
        ...state,
        currentIndex: action.payload.index,
      };
    default:
      return state;
  }
};
